export { FILTER_CASES };

/**
 * Filter syntax for different software and service types
 * @memberof vef.map.filters
 */
const FILTER_CASES = {
    "geoserver": {
        "wms": {},
        "wfs": {}
    },
    "esri": {
        "wms": {},
        "wfs": {},
        "ims": {}
    },
    "rasdaman": {
        "wms": {}
    },
    "thredds": {
        "wms": {}
    }
};

// GEOSERVER

FILTER_CASES.geoserver.wms.ogc = {
    "format": "xml",
    "prefix": "filter",
    "syntax": '<Filter xmlns="http://www.opengis.net/ogc">%SYNTAX%</Filter>',
    "filter": "%FILTER%",
    "identify": 'filter=<Filter xmlns="http://www.opengis.net/ogc">%FILTERS%</Filter>',
    "layers": "%LAYERS%",
    "_identify": '<Filter xmlns="http://www.opengis.net/ogc">%FILTERS%</Filter>',
    "_identify_url": '%URL%?',

    "eq": '<PropertyIsEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%VALUE%</Literal></PropertyIsEqualTo>',
    "bt": '<And><PropertyIsGreaterThanOrEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%MIN%</Literal></PropertyIsGreaterThanOrEqualTo><PropertyIsLessThanOrEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%MAX%</Literal></PropertyIsLessThanOrEqualTo></And>',
    "gt": '<PropertyIsGreaterThanOrEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%VALUE%</Literal></PropertyIsGreaterThanOrEqualTo>',
    "lt": '<PropertyIsLessThanOrEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%VALUE%</Literal></PropertyIsLessThanOrEqualTo>',
    "null": '<PropertyIsNull><PropertyName>%COLUMN%</PropertyName></PropertyIsNull>',
    "like": `<PropertyIsLike wildCard="*" singleChar="#" escapeChar="!"><PropertyName>%COLUMN%</PropertyName><Literal>%VALUE%</Literal></PropertyIsLike>`,

    'and': '<And>%FILTER%</And>',
    'or': '<Or>%FILTER%</Or>',
    '_typeof': {
        'string': "%VALUE%",
        'number': "%VALUE%"
    }
};

FILTER_CASES.geoserver.wms.dimension = {
    "format": "json",
    "syntax": '%SYNTAX%',
    "eq": '%VALUE%',
    "bt": '%MIN%/%MAX%',
    'and': ',%FILTER%',
    'or': ',%FILTER%',
    '_typeof': {
        'string': "%VALUE%",
        'number': "%VALUE%"
    },

    "prefix": "",
    "gt": '%VALUE%/9999-12-31T23:59:59.999Z',
    "lt": '0001-01-01T00:00:00.0Z/%VALUE%',
    "_identify_url": '%URL%?',
    "filter": "%FILTER%",
    "layers": "%LAYERS%",
};

FILTER_CASES.geoserver.wfs.ogc = {
    "format": "xml",
    "prefix": "Filter",
    "syntax": '<Filter>%SYNTAX%</Filter>',
    "filter": "%FILTER%",

    "identify": 'Filter=<Filter>%FILTERS%</Filter>',
    "layers": "",
    "_identify": '<Filter>%FILTERS%</Filter>',
    "_identify_url": '%URL%/identify',

    "eq": '<PropertyIsEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%VALUE%</Literal></PropertyIsEqualTo>',
    "bt": '<And><PropertyIsGreaterThanOrEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%MIN%</Literal></PropertyIsGreaterThanOrEqualTo><PropertyIsLessThanOrEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%MAX%</Literal></PropertyIsLessThanOrEqualTo></And>',
    "gt": '<PropertyIsGreaterThanOrEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%VALUE%</Literal></PropertyIsGreaterThanOrEqualTo>',
    "lt": '<PropertyIsLessThanOrEqualTo><PropertyName>%COLUMN%</PropertyName><Literal>%VALUE%</Literal></PropertyIsLessThanOrEqualTo>',
    "null": '<PropertyIsNull><PropertyName>%COLUMN%</PropertyName></PropertyIsNull>',
    "like": `<PropertyIsLike wildCard="*" singleChar="#" escapeChar="!"><PropertyName>%COLUMN%</PropertyName><Literal>%VALUE%</Literal></PropertyIsLike>`,

    'and': '<And>%FILTER%</And>',
    'or': '<Or>%FILTER%</Or>',
    '_typeof': {
        'string': "%VALUE%",
        'number': "%VALUE%"
    }
};

// ESRI

FILTER_CASES.esri.wms.cql = {
    "format": "json",
    "prefix": "layerDefs",
    "syntax": '\{%SYNTAX%\}',
    "filter": '\"%LAYER%\":\"%FILTER%\"',

    "identify": "layers=all:%LAYERS%&LayerDefs={%FILTERS%}",
    "layers": "all:%LAYERS%",
    "_identify": '\{%FILTERS%\}',
    "_identify_url": '%URL%/identify',

    "eq": "(%COLUMN%=%VALUE%)",
    "bt": "\(%COLUMN% >= %MIN%\) AND \( %COLUMN% <= %MAX%\)",
    "gt": "(%COLUMN%>%VALUE%)",
    "lt": "(%COLUMN%<%VALUE%)",
    "gteq": "(%COLUMN%>=%VALUE%)",
    "lteq": "(%COLUMN%<=%VALUE%)",

    'and': ' AND \(%FILTER%\)',
    'or': ' OR %FILTER%',
    '_typeof': {
        'string': "\'%VALUE%\'",
        'number': "%VALUE%"
    }
};

FILTER_CASES.esri.wms.dimension = FILTER_CASES.geoserver.wms.dimension;

FILTER_CASES.esri.wms.cql_imageserver = {
    "format": "json",
    "prefix": "Query",
    "syntax": '%SYNTAX%',
    "filter": "%FILTER%", //TODO Check if it's right!

    "identify": 'mosaicRule=\{\"WHERE\":\"\%FILTERS%"\}',
    "layers": "",
    "_identify": '\{\"WHERE\":\"\%FILTERS%"\}',
    "_identify_url": '%URL%/identify',

    "eq": "(%COLUMN%=%VALUE%)",
    "bt": "\(%COLUMN% BETWEEN %MIN% AND %MAX%\)",
    "gt": "(%COLUMN%>%VALUE%)",
    "lt": "(%COLUMN%<%VALUE%)",

    'and': ' AND \(%FILTER%\)',
    'or': ' OR %FILTER%',
    '_typeof': {
        'string': "\'%VALUE%\'",
        'number': "%VALUE%"
    }
};

FILTER_CASES.esri.ims.dimension = FILTER_CASES.geoserver.wms.dimension;

FILTER_CASES.esri.wfs.ogc = {
    "format": "xml",
    "prefix": "Filter",
    "syntax": '<ogc:Filter xmlns="http://www.opengis.net/ogc">%SYNTAX%</ogc:Filter>',
    "filter": "%FILTER%",

    "identify": 'Filter=<ogc:Filter>%FILTERS%</ogc:Filter>',
    "layers": "",
    "_identify": '<ogc:Filter>%FILTERS%</ogc:Filter>',
    "_identify_url": '%URL%/identify',

    "eq": '<ogc:PropertyIsEqualTo><ogc:PropertyName>%COLUMN%</ogc:PropertyName><ogc:Literal>%VALUE%</ogc:Literal></ogc:PropertyIsEqualTo>',
    "bt": '<ogc:And><ogc:PropertyIsGreaterThanOrEqualTo><ogc:PropertyName>%COLUMN%</ogc:PropertyName><ogc:Literal>%MIN%</ogc:Literal></ogc:PropertyIsGreaterThanOrEqualTo><ogc:PropertyIsLessThanOrEqualTo><ogc:PropertyName>%COLUMN%</ogc:PropertyName><ogc:Literal>%MAX%</ogc:Literal></ogc:PropertyIsLessThanOrEqualTo></ogc:And>',
    "gt": '<ogc:PropertyIsGreaterThanOrEqualTo><ogc:PropertyName>%COLUMN%</ogc:PropertyName><ogc:Literal>%VALUE%</ogc:Literal></ogc:PropertyIsGreaterThanOrEqualTo>',
    "lt": '<ogc:PropertyIsLessThanOrEqualTo><ogc:PropertyName>%COLUMN%</ogc:PropertyName><ogc:Literal>%VALUE%</ogc:Literal></ogc:PropertyIsLessThanOrEqualTo>',

    'and': '<ogc:And>%FILTER%</ogc:And>',
    'or': '<ogc:Or>%FILTER%</ogc:Or>',
    '_typeof': {
        'string': "%VALUE%",
        'number': "%VALUE%"
    }
};

FILTER_CASES.esri.wfs.dimension = FILTER_CASES.geoserver.wms.dimension;

// RASDAMAN

FILTER_CASES.rasdaman.wms.dimension = FILTER_CASES.geoserver.wms.dimension;

// THREDDS

FILTER_CASES.thredds.wms.dimension = FILTER_CASES.geoserver.wms.dimension;